import * as firebase from 'firebase'

export const sendEmail = data => {
  const sendEmailFunction = firebase.functions().httpsCallable('sendEmail')
  return sendEmailFunction(data)
}



// WEBPACK FOOTER //
// ./src/customFunctions.js